"use client";
import { jsx } from "react/jsx-runtime";
import { COMPONENT_NAME_MULTI_ROW, DESKTOP_DEFAULT_TILES_PER_ROW } from "./constants.js";
import { MultiRowContainer, CategoryTileContainer } from "./styles.js";
const MultiRow = ({
  ads,
  maxTilesPerRow
}) => {
  const itemsPerRow = maxTilesPerRow ? maxTilesPerRow : DESKTOP_DEFAULT_TILES_PER_ROW;
  return /* @__PURE__ */ jsx(MultiRowContainer, { "data-testid": COMPONENT_NAME_MULTI_ROW, children: ads.map((ad, index) => {
    return /* @__PURE__ */ jsx(
      CategoryTileContainer,
      {
        itemsPerRow,
        children: ad
      },
      index
    );
  }) });
};
export {
  MultiRow
};
